import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';

import { listDevices } from '../../redux/actions/deviceActions';
import Devices from './Devices';

const Modal = ({ serverOfflineSince, serverStatus, serverName, site, userBusinessRole }) => { 

  const dispatch = useDispatch();
  const user = localStorage.getItem('email');

  // Always clone the array before sorting to avoid mutating Redux state
  const devices = useSelector(state => state.devices);
  const currentDevices = [...devices].sort((a, b) => {
    if (a.cameraStatus > b.cameraStatus) return 1;
    if (a.cameraStatus < b.cameraStatus) return -1;
    return a.cameraName.localeCompare(b.cameraName);
  });

  const [loading, setLoading] = useState(true);

  // Reset loading when the server changes
  useEffect(() => {
    setLoading(true);
  }, [serverName]);

  // Fetch devices when server changes
  useEffect(() => {
    if (serverName) {
      dispatch(listDevices(serverName, user, site));
    }
  }, [serverName, dispatch, user, site]);

  // Stop loading once devices update
  useEffect(() => {
    if (devices.length > 0) {
      setLoading(false);
    }
  }, [devices]);

  return (
    <div> 
      {loading ? (
        <div style={{ marginTop: '2em', textAlign: 'center' }}>
          <BeatLoader size={10} color="#64C6E6"/>
        </div>
      ) : (
        <Devices
          serverOfflineSince={serverOfflineSince}
          devices={currentDevices}
          serverStatus={serverStatus}
          serverName={serverName}
          site={site}
          userBusinessRole={userBusinessRole}
        />
      )}           
    </div>
  );
};

export default Modal;
